<script setup lang="ts">
defineOptions({ inheritAttrs: false })
</script>

<template>
  <div class="flex items-center px-4 pb-4 pt-6" v-bind="$attrs">
    <slot></slot>
  </div>
</template>
